import script from "./ChatBI.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBI.vue?vue&type=script&setup=true&lang=js"

import "./ChatBI.vue?vue&type=style&index=0&id=1084b2b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1084b2b0"]])

export default __exports__